import styled from 'styled-components';

export const SubtleMeta = styled.div`
  font-size: 11px;
  line-height: 16px;
  color: #8f8f8f;
`;
